import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import {
  Courses,
  UploadCourseCardTitle,
  UploadCoursePageTitle,
} from "../../../constants";

import AjaxSourcedData from "../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData";
import { coursesList } from "../../../data/courses/coursesList";
import {
  getVideoListTableColumns,
  VideoListTableColumns,
  VideoListTableSubtitle,
} from "../../../data/formsAndTable/tables/dataTables/DataSource";
import { VideoData } from "../../../types/Tables";
import { useState } from "react";
import SimpleModal from "../../uiKits/modal/basicModal/SimpleModal";
import UploadModalContent from "./UploadModalContent";
import UploadResult from "./UploadResult";
import { useTranslation } from "react-i18next";
import { NoDataComponent } from "../../formsAndTable/forms/formControls/NoDataComponent";
interface Props {
  videoList: VideoData[];
  isLoading?: boolean;
}
const UploadCoursePageContainer: React.FC<Props> = ({ videoList, isLoading }) => {
  const {t} = useTranslation()
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  return (
    <>
      <Breadcrumbs mainTitle={t("video.uploadCoursePageTitle")}  />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={t("video.studyVideos")} tag />
              <CardBody>
                <AjaxSourcedData
                  data={videoList}
                  columns={getVideoListTableColumns(t)}
                  noDataComponent={<NoDataComponent />}
                  loading={isLoading}
                  // title="Ajax Source Table"
                  // subTitle={
                  //   Array.isArray(VideoListTableSubtitle)
                  //     ? VideoListTableSubtitle.map((sub) => sub.text).join(", ")
                  //     : VideoListTableSubtitle
                  // }
                />
              </CardBody>
              {/* <CardBody>
                <p>{"Add new video."}</p>
                <Button onClick={() => setModalIsOpen(true)}>
                  Add new video
                </Button>
              </CardBody> */}
            </Card>
          </Col>
        </Row>
      </Container>
      <SimpleModal isOpen={modalIsOpen} close={() => setModalIsOpen(false)}>
        <UploadModalContent
          setUploadSuccess={setUploadSuccess}
          setShowConfirm={setShowConfirm}
          close={() => setModalIsOpen(false)}
        />
      </SimpleModal>
      <SimpleModal isOpen={showConfirm} close={() => setShowConfirm(false)}>
        <UploadResult
          uploadSuccess={uploadSuccess}
          setShowConfirm={setShowConfirm}
          close={() => setShowConfirm(false)}
        />
      </SimpleModal>
    </>
  );
};
export default UploadCoursePageContainer;
